import React, { Dispatch, FC, useCallback } from 'react';
import { Button, FormGroup, Label } from 'reactstrap';
import { MaterialIcon } from '../../components';
import { useTranslation } from '../../translations';
import { FormActionType } from '../form/FormReducer';

interface RandomizeBadgeInfoButtonProps {
  readonly dispatch: Dispatch<FormActionType>;
}

export const RandomizeBadgeInfoButton: FC<RandomizeBadgeInfoButtonProps> = ({ dispatch }) => {
  const randomizeBadgeInfo = useCallback(() => {
    dispatch({ type: 'randomizeBadgeInfo' });
  }, [dispatch]);

  const { ts } = useTranslation();

  return (
    <FormGroup>
      <Label for="randomBadgeInfo">{ts('randomize')}</Label>
      <Button block color="primary" id="randomBadgeInfo" onClick={randomizeBadgeInfo} outline>
        <MaterialIcon className="align-middle" name="shuffle" />
      </Button>
    </FormGroup>
  );
};
